import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Menu } from '@linktivity/link-ui';
import { useStore } from '@/stores';
import styles from './sidebar.module.css';

const Sidebar = () => {
  const { t } = useTranslation();
  const { product } = useStore();

  return (
    <aside className={styles.sidebar}>
      <div className={styles.inner}>
        <Menu className={styles.menu} accordion>
          <Menu.MenuItem label={t('views.dashboard.title')} to="/dashboard" />
          {product?.products?.map(item => (
            <Menu.MenuItem
              key={item?.productId}
              label={item?.productName}
              to={`/reports/${item?.productId}`}
            />
          ))}
        </Menu>
      </div>
    </aside>
  );
};

const ObserverSidebar = observer(Sidebar);
export default ObserverSidebar;
